export default "__VITE_ASSET__z1iqEy3G__"